import {cancelled, call, takeLatest, put} from 'redux-saga/effects'
import {dataConstants, alertConstants} from '../constants'
import {dataActions, userActions, alertActions} from '../actions'
import {
    getDataAPI,
    swipeDataAPI,
    batchswipeDataAPI,
    lookupDataAPI,
    postDataAPI,
    putDataAPI,
    patchDataAPI,
    deleteDataAPI,
} from '../utils/DataService'
import * as R from 'ramda'

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/
export function* watchEventCategoryDataRequest() {
    yield takeLatest(
        dataConstants.DATA_EVENTCATEGORY_REQUEST,
        eventcategoryDataSaga
    )
}

export function* watchUpdateEvtCategoryDataRequest() {
    yield takeLatest(
        dataConstants.DATA_UPDATEEVTCATEGORY_REQUEST,
        updateEvtCategoryDataSaga
    )
}

export function* watchSetEvtCategoryDataRequest() {
    yield takeLatest(
        dataConstants.DATA_SETEVTCATEGORY_REQUEST,
        setEvtCategoryDataSaga
    )
}

export function* watchDeleteEvtCategoryDataRequest() {
    yield takeLatest(
        dataConstants.DATA_DELEVTCATEGORY_REQUEST,
        deleteEvtCategoryDataSaga
    )
}

export function* watchAddEvtCategoryDataRequest() {
    yield takeLatest(
        dataConstants.DATA_ADDEVTCATEGORY_REQUEST,
        addEvtCategoryDataSaga
    )
}

export function* watchEventOccurrenceDataRequest() {
    yield takeLatest(
        dataConstants.DATA_GETEVTOCCURRENCES_REQUEST,
        evtoccurrenceDataSaga
    )
}

export function* watchAddEvtOccurrenceDataRequest() {
    yield takeLatest(
        dataConstants.DATA_ADDEVTOCCURRENCES_REQUEST,
        addEvtOccurrenceDataSaga
    )
}

export function* watchUpdateEvtOccurrenceDataRequest() {
    yield takeLatest(
        dataConstants.DATA_UPDEVTOCCURRENCES_REQUEST,
        updateEvtOccurrenceDataSaga
    )
}

export function* watchDeleteEvtOccurrencesDataRequest() {
    yield takeLatest(
        dataConstants.DATA_DELEVTOCCURRENCES_REQUEST,
        deleteEvtOccurrenceDataSaga
    )
}

export function* watchEventDataRequest() {
    yield takeLatest(dataConstants.DATA_EVENT_REQUEST, eventDataSaga)
}

export function* watchOccurDataRequest() {
    yield takeLatest(dataConstants.DATA_OCCURRENCES_REQUEST, occurDataSaga)
}

export function* watchLookupDataRequest() {
    yield takeLatest(dataConstants.DATA_LOOKUP_REQUEST, lookupDataSaga)
}

export function* watchLookupEUIDDataRequest() {
    yield takeLatest(dataConstants.DATA_LOOKUPEUID_REQUEST, lookupEUIDDataSaga)
}

export function* watchSwipeDataRequest() {
    yield takeLatest(dataConstants.DATA_SWIPE_REQUEST, swipeDataSaga)
}

export function* watchGetBatchSwipeEmplidsDataRequest() {
    yield takeLatest(
        dataConstants.DATA_GETBATCHSWIPEEMPLIDS_REQUEST,
        getbatchswipeemplidsDataSaga
    )
}

export function* watchBatchSwipeValidDataRequest() {
    yield takeLatest(
        dataConstants.DATA_BATCHSWIPEVALIDATE_REQUEST,
        batchswipeValidateDataSaga
    )
}

export function* watchBatchSwipeRecordDataRequest() {
    yield takeLatest(
        dataConstants.DATA_BATCHSWIPERECORD_REQUEST,
        batchswipeRecordDataSaga
    )
}

export function* watchSwipeTeamsDataRequest() {
    yield takeLatest(
        dataConstants.DATA_GETSWIPETEAMS_REQUEST,
        swipeteamsDataSaga
    )
}

export function* watchGetDeptSwipeTeamDataRequest() {
    yield takeLatest(
        dataConstants.DATA_GETDEPTSWIPETEAM_REQUEST,
        getswipeteamDataSaga
    )
}

export function* watchAddSwipeTeamDataRequest() {
    yield takeLatest(
        dataConstants.DATA_ADDSWIPETEAM_REQUEST,
        addSwipeTeamDataSaga
    )
}

export function* watchUpdateSwipeTeamDataRequest() {
    yield takeLatest(
        dataConstants.DATA_UPDATESWIPETEAM_REQUEST,
        updateSwipeTeamDataSaga
    )
}

export function* watchDeleteSwipeTeamDataRequest() {
    yield takeLatest(
        dataConstants.DATA_DELETESWIPETEAM_REQUEST,
        deleteSwipeTeamDataSaga
    )
}

export function* watchGetEvtOccurrenceSwiperDataRequest() {
    yield takeLatest(
        dataConstants.DATA_GETEVTOCCURSWIPERS_REQUEST,
        getEvtOccurrenceSwipersDataSaga
    )
}

export function* watchUpdateEvtOccurrenceSwipersDataRequest() {
    yield takeLatest(
        dataConstants.DATA_UPDEVTOCCURSWIPERS_REQUEST,
        updateEvtOccurrenceSwipersDataSaga
    )
}

export function* watchEngagementtypeRequest() {
    yield takeLatest(
        dataConstants.DATA_ENGAGEMENTTYPE_REQUEST,
        engagementtypeSaga
    )
}

export function* watchDepartmentsDataRequest() {
    yield takeLatest(
        dataConstants.DATA_DEPARTMENTS_REQUEST,
        departmentsDataSaga
    )
}

export function* watchSetDepartmentsDataRequest() {
    yield takeLatest(
        dataConstants.DATA_SETACTDEPARTMENT_REQUEST,
        setActiveDepartmentDataSaga
    )
}

export function* watchGetSuperAdminDataRequest() {
    yield takeLatest(
        dataConstants.DATA_GETSUPERADMINS_REQUEST,
        superadminDataSaga
    )
}

export function* watchPutSuperAdminDataRequest() {
    yield takeLatest(
        dataConstants.DATA_PUTSUPERADMIN_REQUEST,
        putSuperAdminDataSaga
    )
}

export function* watchsetManageRoleDeptDataRequest() {
    yield takeLatest(
        dataConstants.DATA_SETMANAGEROLEDEPT_REQUEST,
        setManageRoleDeptDataSaga
    )
}

export function* watchaddManageRolesDeptDataRequest() {
    yield takeLatest(
        dataConstants.DATA_ADDMANAGEROLEDEPT_REQUEST,
        addManageRolesDeptDataSaga
    )
}

export function* watchupdateManageRolesDeptDataRequest() {
    yield takeLatest(
        dataConstants.DATA_UPDMANAGEROLEDEPT_REQUEST,
        updateManageRolesDeptDataSaga
    )
}

export function* watchdeleteManageRolesDeptDataRequest() {
    yield takeLatest(
        dataConstants.DATA_DELMANAGEROLEDEPT_REQUEST,
        deleteManageRolesDeptDataSaga
    )
}

export function* watchgetDepartmentUsersDataRequest() {
    yield takeLatest(
        dataConstants.DATA_GETDEPARTMENTUSERS_REQUEST,
        departmentusersDataSaga
    )
}

export function* watchaddDepartmentUsersDataRequest() {
    yield takeLatest(
        dataConstants.DATA_ADDDEPARTMENTUSERS_REQUEST,
        addDepartmentUsersDataSaga
    )
}

export function* watchupdateDepartmentUsersDataRequest() {
    yield takeLatest(
        dataConstants.DATA_UPDDEPARTMENTUSERS_REQUEST,
        updateDepartmentUsersDataSaga
    )
}

export function* watchdeleteDepartmentUsersDataRequest() {
    yield takeLatest(
        dataConstants.DATA_DELDEPARTMENTUSERS_REQUEST,
        deleteDepartmentUsersDataSaga
    )
}

export function* watchgetAllUsersDataRequest() {
    yield takeLatest(dataConstants.DATA_GETALLUSERS_REQUEST, allusersDataSaga)
}

/******************************************************************************/
/********************************* Sagas **************************************/
/******************************************************************************/
function* eventcategoryDataSaga(action) {
    const abortController = new AbortController()
    let eventcategorylist

    const {token, deptId} = action

    try {
        eventcategorylist = yield call(
            getDataAPI,
            '/events/' + deptId,
            token,
            dataConstants.DATA_EVENTCATEGORY_SUCCESS,
            dataConstants.DATA_EVENTCATEGORY_FAILURE,
            alertConstants.ERROR
        )

        const {statusCode} = eventcategorylist
        if (statusCode === 404) {
            yield put({
                type: dataConstants.DATA_EVENTCATEGORY_SUCCESS,
                data: {events: []},
            })
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_EVENTCATEGORY_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return eventcategorylist
}

function* addEvtCategoryDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {values, activedepartment} = payload
    const body = {
        deptId: activedepartment,
        status: 'A',
        name: values.newcategoryname,
        descr: values.newcategorycomments,
    }

    try {
        data = yield call(
            postDataAPI,
            '/events/' + activedepartment,
            token,
            body,
            dataConstants.DATA_ADDEVTCATEGORY_SUCCESS,
            dataConstants.DATA_ADDEVTCATEGORY_FAILURE,
            alertConstants.ERROR
        )

        if (data) {
            yield put(
                dataActions.eventcategorySetRequest({
                    token,
                    eventcat: data,
                })
            )
            yield put(
                alertActions.success(
                    'Created ' + values.newcategoryname + ' event category.'
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_ADDEVTCATEGORY_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* updateEvtCategoryDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {values, currenteventcategory} = payload
    const eventcategory = {
        ...currenteventcategory,
        name: values.categoryname,
        descr: values.categorycomments,
    }
    try {
        data = yield call(
            patchDataAPI,
            '/events/' + eventcategory.deptId + '/' + eventcategory.id,
            token,
            eventcategory,
            dataConstants.DATA_UPDATEEVTCATEGORY_SUCCESS,
            dataConstants.DATA_UPDATEEVTCATEGORY_FAILURE,
            alertConstants.ERROR
        )

        if (data) {
            yield put(
                dataActions.eventcategorySetRequest({
                    token,
                    eventcat: data,
                })
            )
            yield put(
                alertActions.success(
                    'Updated ' + currenteventcategory.name + ' event category.'
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_UPDATEEVTCATEGORY_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* deleteEvtCategoryDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {currenteventcategory} = payload
    const {deptId, id} = currenteventcategory

    try {
        data = yield call(
            deleteDataAPI,
            '/events/' + deptId + '/' + id,
            token,
            dataConstants.DATA_DELEVTCATEGORY_SUCCESS,
            dataConstants.DATA_DELEVTCATEGORY_FAILURE,
            alertConstants.ERROR
        )
        if (data) {
            yield put(dataActions.eventcategoryFetchRequest(token, deptId))
            yield put(
                alertActions.success(
                    'Deleted ' + currenteventcategory.name + ' event category.'
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_DELEVTCATEGORY_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* setEvtCategoryDataSaga(action) {
    const abortController = new AbortController()
    let activeEventCategory

    const {token, eventcat: eventcategory} = action.payload

    try {
        if (!R.isEmpty(action.payload)) {
            activeEventCategory = eventcategory
            yield put(dataActions.eventcategorySetSuccess(activeEventCategory))
            // call get event occurrences data saga
            yield put(
                dataActions.eventoccurGetRequest({token, activeEventCategory})
            )
        } else {
            activeEventCategory = {}
            yield put(dataActions.eventcategorySetClear(activeEventCategory))
            // call get event occurrences data saga
            yield put(dataActions.eventoccurGetRequest({}))
        }
    } catch (err) {
        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_SETEVTCATEGORY_FAILURE,
            message: err,
        })
        yield put({type: alertConstants.ERROR, message: err})
    }

    // return the active event category instance
    return activeEventCategory
}

function* evtoccurrenceDataSaga(action) {
    const abortController = new AbortController()
    let activeoccurrence
    let result

    const {token, activeEventCategory} = action.payload

    try {
        if (!R.isEmpty(action.payload) && activeEventCategory) {
            result = yield call(
                getDataAPI,
                '/occurrences/' +
                    activeEventCategory.deptId +
                    '/' +
                    activeEventCategory.id,
                token,
                dataConstants.DATA_GETEVTOCCURRENCES_SUCCESS,
                dataConstants.DATA_GETEVTOCCURRENCES_FAILURE,
                alertConstants.ERROR
            )

            if (result) {
                activeoccurrence = result
            } else {
                activeoccurrence = []
                yield put(dataActions.eventoccurGetClear(activeoccurrence))
            }
        } else {
            activeoccurrence = []
            yield put(dataActions.eventoccurGetClear(activeoccurrence))
        }
    } catch (err) {
        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_GETEVTOCCURRENCES_FAILURE,
            message: err,
        })
        yield put({type: alertConstants.ERROR, message: err})
    }

    // return the active event occurrence instance
    return activeoccurrence
}

function* addEvtOccurrenceDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {
        values,
        deptId,
        selectedStartDate,
        selectedEndDate,
        swiperarray,
        eventcatName,
    } = payload

    let allowDuplicate
    let timeoutDuplicate
    if (typeof values.duplicateswipe === 'number') {
        allowDuplicate = 'T'
        timeoutDuplicate = values.duplicateswipe
    } else {
        allowDuplicate = values.duplicateswipe
        timeoutDuplicate = 0
    }

    const body = {
        deptId: deptId,
        occurTitle: values.newoccurrencename,
        dateStart: selectedStartDate.toISOString(),
        dateEnd: selectedEndDate.toISOString(),
        timeStart: selectedStartDate.toISOString(),
        timeEnd: selectedEndDate.toISOString(),
        isKiosk: values.suspendautologout ? 'Y' : 'N',
        occurInstructions: values.newoccurrenceinstructions
            ? values.newoccurrenceinstructions
            : 'Place swiper instructions here',
        occurMessage: values.newoccurrencemessage
            ? values.newoccurrencemessage
            : 'Please login below to join our event',
        isEnrolled: values.whocanattend === 'Students' ? 'Y' : 'N',
        isEmployed:
            values.whocanattend === 'Employees'
                ? 'Y'
                : values.whocanattend === 'EmployeesFulltime'
                ? 'F'
                : 'N',
        status: 'A',
        duplicateAllow: allowDuplicate,
        duplicateTimeout: timeoutDuplicate,
        engagementType: values.engagementtype,
        occurKind:
            values.isvirtual === 'In-person'
                ? 'I'
                : values.isvirtual === 'Virtual Only'
                ? 'O'
                : 'H',
        isVirtualHidden: values.isvirtualhidden ? 'Y' : 'N',
        virtualMessage: values.redirectlink,
    }

    try {
        data = yield call(
            postDataAPI,
            '/occurrences/' + deptId + '/' + values.eventcategory,
            token,
            body,
            dataConstants.DATA_ADDEVTOCCURRENCES_SUCCESS,
            dataConstants.DATA_ADDEVTOCCURRENCES_FAILURE,
            alertConstants.ERROR
        )

        if (data) {
            const eventId = data.eventId
            const occurId = data.occurId
            const addswiperpayload = {swiperarray, deptId, eventId, occurId}
            yield put({
                type: dataConstants.DATA_UPDEVTOCCURSWIPERS_REQUEST,
                token,
                payload: addswiperpayload,
            })

            if (eventcatName && eventcatName.length > 0) {
                yield put(
                    alertActions.success(
                        'Moved ' +
                            values.newoccurrencename +
                            ' event to ' +
                            eventcatName[0].name
                    )
                )
            } else {
                yield put(
                    alertActions.success(
                        'Created ' + values.newoccurrencename + ' event.'
                    )
                )
            }
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_ADDEVTOCCURRENCES_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* updateEvtOccurrenceDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {
        values,
        occurId,
        departmentId,
        selectedStartDate,
        selectedEndDate,
        status,
    } = payload

    let allowDuplicate
    let timeoutDuplicate
    if (typeof values.duplicateswipe === 'number') {
        allowDuplicate = 'T'
        timeoutDuplicate = values.duplicateswipe
    } else {
        allowDuplicate = values.duplicateswipe
        timeoutDuplicate = 0
    }

    const body = {
        deptId: departmentId,
        occurTitle: values.occurrencename,
        dateStart: selectedStartDate.toISOString(),
        dateEnd: selectedEndDate.toISOString(),
        timeStart: selectedStartDate.toISOString(),
        timeEnd: selectedEndDate.toISOString(),
        isKiosk: values.suspendautologout ? 'Y' : 'N',
        occurInstructions: values.occurrenceinstructions
            ? values.occurrenceinstructions
            : 'Place swiper instructions here',
        occurMessage: values.occurrencemessage
            ? values.occurrencemessage
            : 'Please login below to join our event',
        isEnrolled: values.whocanattend === 'Students' ? 'Y' : 'N',
        isEmployed:
            values.whocanattend === 'Employees'
                ? 'Y'
                : values.whocanattend === 'EmployeesFulltime'
                ? 'F'
                : 'N',
        status: status,
        duplicateAllow: allowDuplicate,
        duplicateTimeout: timeoutDuplicate,
        engagementType: values.engagementtype,
        occurKind:
            values.isvirtual === 'In-person'
                ? 'I'
                : values.isvirtual === 'Virtual Only'
                ? 'O'
                : 'H',
        isVirtualHidden: values.isvirtualhidden ? 'Y' : 'N',
        virtualMessage: values.redirectlink,
    }

    try {
        data = yield call(
            patchDataAPI,
            '/occurrences/' +
                departmentId +
                '/' +
                values.eventcategory +
                '/' +
                occurId,
            token,
            body,
            dataConstants.DATA_UPDEVTOCCURRENCES_SUCCESS,
            dataConstants.DATA_UPDEVTOCCURRENCES_FAILURE,
            alertConstants.ERROR
        )

        if (data)
            yield put(
                alertActions.success(
                    'Updated ' + values.occurrencename + ' event.'
                )
            )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_UPDEVTOCCURRENCES_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

/**************** Deleting Event Occurrences - Consists of 2 Sagas below **********************************/
function* deleteEvtOccurrenceSaga(token, occurrence) {
    const abortController = new AbortController()
    let data

    try {
        data = yield call(
            deleteDataAPI,
            '/occurrences/' +
                occurrence.deptId +
                '/' +
                occurrence.eventId +
                '/' +
                occurrence.occurId,
            token,
            dataConstants.DATA_DELEVTOCCURRENCES_SUCCESS,
            dataConstants.DATA_DELEVTOCCURRENCES_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_DELEVTOCCURRENCES_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* deleteEvtOccurrenceDataSaga(action) {
    const {token, payload} = action
    const {eventoccurrences} = payload
    const eventcategoryId = eventoccurrences[0].eventId
    const deptId = eventoccurrences[0].deptId
    let status
    let deleteCount = 0

    for (let occurrence of eventoccurrences) {
        status = yield call(deleteEvtOccurrenceSaga, token, occurrence)

        if (status === 204) deleteCount++
    }
    if (deleteCount > 0) {
        if (deleteCount > 1) {
            yield put(
                alertActions.success(
                    'Deleted ' + deleteCount + ' event occurrences'
                )
            )
        } else
            yield put(
                alertActions.success(
                    'Deleted ' + deleteCount + ' event occurrence'
                )
            )
    }
    yield put(
        dataActions.eventoccurGetRequest({
            token,
            activeEventCategory: {deptId, id: eventcategoryId},
        })
    )
}

/**** Get Event Occurrence Swipers */
function* getEvtOccurrenceSwipersDataSaga(action) {
    const abortController = new AbortController()
    let swipers

    const {token, payload} = action
    const {deptId, eventId, occurId} = payload

    try {
        swipers = yield call(
            getDataAPI,
            '/swipe-management/swipers/' +
                deptId +
                '/' +
                eventId +
                '/' +
                occurId,
            token,
            dataConstants.DATA_GETEVTOCCURSWIPERS_SUCCESS,
            dataConstants.DATA_GETEVTOCCURSWIPERS_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_GETEVTOCCURSWIPERS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    // return the event occurrence swipers data
    return swipers
}

/**** Replace Event Occurrence Swipers */
function* updateEvtOccurrenceSwipersDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {swiperarray, deptId, eventId, occurId} = payload

    const swipers = []
    swiperarray.forEach(element => {
        swipers.push(element.euid)
    })

    const body = {
        swipers: swipers,
    }

    try {
        data = yield call(
            putDataAPI,
            '/swipe-management/swipers/' +
                deptId +
                '/' +
                eventId +
                '/' +
                occurId,
            token,
            body,
            dataConstants.DATA_UPDEVTOCCURSWIPERS_SUCCESS,
            dataConstants.DATA_UPDEVTOCCURSWIPERS_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_UPDEVTOCCURSWIPERS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* eventDataSaga(action) {
    const abortController = new AbortController()
    let eventlist

    const {token} = action

    try {
        eventlist = yield call(
            getDataAPI,
            '/occurrences',
            token,
            dataConstants.DATA_EVENT_SUCCESS,
            dataConstants.DATA_EVENT_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_EVENT_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return eventlist
}

function* occurDataSaga(action) {
    const abortController = new AbortController()
    let activeoccurrence
    let result

    const {token, occurrence} = action.payload

    try {
        if (!R.isEmpty(action.payload)) {
            result = yield call(
                getDataAPI,
                '/swipe-management/swipe/' +
                    occurrence.eventId +
                    '/' +
                    occurrence.occurId,
                token,
                dataConstants.DATA_OCCURRENCES_SUCCESS,
                dataConstants.DATA_OCCURRENCES_FAILURE,
                alertConstants.ERROR
            )

            if (result) {
                activeoccurrence = result
            } else {
                activeoccurrence = {}
                yield put(dataActions.occurSetClear(activeoccurrence))
            }
        } else {
            activeoccurrence = {}
            yield put(dataActions.occurSetClear(activeoccurrence))
        }
    } catch (err) {
        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_OCCURRENCES_FAILURE,
            message: err,
        })
        yield put({type: alertConstants.ERROR, message: err})
    }

    // return the active event occurrence instance
    return activeoccurrence
}

function* lookupDataSaga(action) {
    const abortController = new AbortController()
    let getresult

    const {token, values} = action

    try {
        getresult = yield call(
            lookupDataAPI,
            '/lookup',
            token,
            values,
            dataConstants.DATA_LOOKUP_SUCCESS,
            dataConstants.DATA_LOOKUP_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_LOOKUP_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    // return the lookup data
    return getresult
}

function* lookupEUIDDataSaga(action) {
    const abortController = new AbortController()
    let getresult

    const {token, euid} = action

    try {
        getresult = yield call(
            getDataAPI,
            '/lookup/' + euid,
            token,
            dataConstants.DATA_LOOKUPEUID_SUCCESS,
            dataConstants.DATA_LOOKUPEUID_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_LOOKUPEUID_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    // return the lookup data
    return getresult
}

function* swipeDataSaga(action) {
    const abortController = new AbortController()
    let swiperesult

    const {token, eventId, occurId, emplId} = action

    try {
        swiperesult = yield call(
            swipeDataAPI,
            '/swipe-management/swipe/' + eventId + '/' + occurId,
            token,
            emplId,
            dataConstants.DATA_SWIPE_SUCCESS,
            dataConstants.DATA_SWIPE_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_SWIPE_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    // return the swipe data
    return swiperesult
}

/*  GET emplids that are already swiped for an event occurrence */
function* getbatchswipeemplidsDataSaga(action) {
    const abortController = new AbortController()
    let result

    const {token, deptId, eventId, occurId} = action

    try {
        result = yield call(
            getDataAPI,
            '/swipe-management/batch/' + deptId + '/' + eventId + '/' + occurId,
            token,
            dataConstants.DATA_GETBATCHSWIPEEMPLIDS_SUCCESS,
            dataConstants.DATA_GETBATCHSWIPEEMPLIDS_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_GETBATCHSWIPEEMPLIDS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    // return the swipe data
    return result
}

/****************** Sagas to perform validate batch swipe - 2 sagas below *****************/
function* batchswipeValidateSaga(
    token,
    deptId,
    eventId,
    occurId,
    swipeIdArray
) {
    const abortController = new AbortController()
    let swiperesult

    try {
        swiperesult = yield call(
            batchswipeDataAPI,
            '/swipe-management/batch/validate/' +
                deptId +
                '/' +
                eventId +
                '/' +
                occurId,
            token,
            null,
            swipeIdArray,
            dataConstants.DATA_BATCHSWIPEVALIDATE_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_BATCHSWIPEVALIDATE_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    // return the swipe data
    return swiperesult
}

function* batchswipeValidateDataSaga(action) {
    let swiperesult
    let totalvalidCount = 0
    let totalinvalidCount = 0
    let validSwipes = []
    let invalidSwipes = []

    const {token, deptId, eventId, occurId, swipeIdArray} = action

    const arraychunks = (array, chunksize) =>
        Array(Math.ceil(array.length / chunksize))
            .fill()
            .map((_, index) => index * chunksize)
            .map(begin => array.slice(begin, begin + chunksize))

    const chunkedArrays = arraychunks(swipeIdArray, 200)

    for (let chunk of chunkedArrays) {
        swiperesult = yield call(
            batchswipeValidateSaga,
            token,
            deptId,
            eventId,
            occurId,
            chunk
        )

        if (swiperesult) {
            const {
                validCount,
                invalidCount,
                validSwipeIds,
                invalidSwipeIds,
            } = swiperesult

            totalvalidCount = validCount
                ? totalvalidCount + validCount
                : totalvalidCount
            totalinvalidCount = invalidCount
                ? totalinvalidCount + invalidCount
                : totalinvalidCount
            validSwipes = validSwipeIds
                ? [...validSwipes, ...validSwipeIds]
                : validSwipes
            invalidSwipes = invalidSwipeIds
                ? [...invalidSwipes, ...invalidSwipeIds]
                : invalidSwipes
        }
    }

    const data = {
        validCount: totalvalidCount,
        invalidCount: totalinvalidCount,
        validSwipeIds: validSwipes,
        invalidSwipeIds: invalidSwipes,
    }

    yield put({type: dataConstants.DATA_BATCHSWIPEVALIDATE_SUCCESS, data})
    if (swipeIdArray.length > 0) {
        yield put(alertActions.success('Batch Upload File Validated. '))
    } else {
        yield put(alertActions.warning('Files are missing ID Headers. '))
    }

    // return the swipe data
    return swiperesult
}

/****************** Saga to perform actual batch swipe *****************/
function* batchswipeRecordSaga(
    token,
    deptId,
    eventId,
    occurId,
    selectedStartDate,
    swipeIdArray
) {
    const abortController = new AbortController()
    let swiperesult
    const startDate = selectedStartDate.toISOString()

    try {
        swiperesult = yield call(
            batchswipeDataAPI,
            '/swipe-management/batch/swipe/' +
                deptId +
                '/' +
                eventId +
                '/' +
                occurId,
            token,
            startDate,
            swipeIdArray,
            dataConstants.DATA_BATCHSWIPERECORD_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_BATCHSWIPERECORD_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    // return the swipe data
    return swiperesult
}

function* batchswipeRecordDataSaga(action) {
    let swiperesult
    let totalswipecount = 0
    let acceptedSwipes = []
    let rejectedSwipes = []

    const {
        token,
        deptId,
        eventId,
        occurId,
        selectedStartDate,
        swipeIdArray,
    } = action

    const arraychunks = (array, chunksize) =>
        Array(Math.ceil(array.length / chunksize))
            .fill()
            .map((_, index) => index * chunksize)
            .map(begin => array.slice(begin, begin + chunksize))

    if (swipeIdArray.length > 200) {
        const chunkedArrays = arraychunks(swipeIdArray, 200)

        for (let chunk of chunkedArrays) {
            swiperesult = yield call(
                batchswipeRecordSaga,
                token,
                deptId,
                eventId,
                occurId,
                selectedStartDate,
                chunk
            )

            const {swipeCount, swipped, denied} = swiperesult
            totalswipecount = swipeCount ? swipeCount : totalswipecount
            acceptedSwipes = swipped
                ? [...acceptedSwipes, ...swipped]
                : acceptedSwipes
            rejectedSwipes = denied
                ? [...rejectedSwipes, ...denied]
                : rejectedSwipes
        }
    } else {
        swiperesult = yield call(
            batchswipeRecordSaga,
            token,
            deptId,
            eventId,
            occurId,
            selectedStartDate,
            swipeIdArray
        )

        const {swipeCount, swipped, denied} = swiperesult
        totalswipecount = swipeCount ? swipeCount : totalswipecount
        acceptedSwipes = swipped
            ? [...acceptedSwipes, ...swipped]
            : acceptedSwipes
        rejectedSwipes = denied
            ? [...rejectedSwipes, ...denied]
            : rejectedSwipes
    }

    const data = {
        eventId,
        occurId,
        swipeCount: totalswipecount,
        acceptedSwipes,
        rejectedSwipes,
    }
    yield put({type: dataConstants.DATA_BATCHSWIPERECORD_SUCCESS, data})
    if (swipeIdArray.length > 0) {
        yield put(alertActions.success('Batch Upload File Validated. '))
    } else {
        yield put(alertActions.warning('Files are missing ID Headers. '))
    }

    // return the swipe data
    return swiperesult
}

function* swipeteamsDataSaga(action) {
    const abortController = new AbortController()
    let swipeteams

    const {token, deptId} = action

    try {
        swipeteams = yield call(
            getDataAPI,
            '/swipe-management/lists/' + deptId,
            token,
            dataConstants.DATA_GETSWIPETEAMS_SUCCESS,
            dataConstants.DATA_GETSWIPETEAMS_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_GETSWIPETEAMS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return swipeteams
}

function* getswipeteamDataSaga(action) {
    const abortController = new AbortController()
    let swipeteam

    const {token, payload} = action

    try {
        swipeteam = yield call(
            getDataAPI,
            '/swipe-management/lists/' + payload.deptId + '/' + payload.listId,
            token,
            dataConstants.DATA_GETDEPTSWIPETEAM_SUCCESS,
            dataConstants.DATA_GETDEPTSWIPETEAM_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_GETDEPTSWIPETEAM_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return swipeteam
}

function* addSwipeTeamDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {values, swiperarray, deptId} = payload

    const swipers = []
    swiperarray.forEach(element => {
        swipers.push(element.euid)
    })

    const body = {
        listName: values.swiperteamname,
        swipers: swipers,
    }

    try {
        data = yield call(
            postDataAPI,
            '/swipe-management/lists/' + deptId,
            token,
            body,
            dataConstants.DATA_ADDSWIPETEAM_SUCCESS,
            dataConstants.DATA_ADDSWIPETEAM_FAILURE,
            alertConstants.ERROR
        )

        if (data) {
            yield put(
                alertActions.success(
                    'Created ' + values.swiperteamname + ' swipe team.'
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_ADDSWIPETEAM_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* updateSwipeTeamDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {values, swiperarray, deptId, listId} = payload

    const swipers = []
    swiperarray.forEach(element => {
        swipers.push(element.euid)
    })

    const body = {
        listName: values.swiperteamname,
        swipers: swipers,
    }

    try {
        data = yield call(
            putDataAPI,
            '/swipe-management/lists/' + deptId + '/' + listId,
            token,
            body,
            dataConstants.DATA_UPDATESWIPETEAM_SUCCESS,
            dataConstants.DATA_UPDATESWIPETEAM_FAILURE,
            alertConstants.ERROR
        )
        if (data) {
            yield put(
                alertActions.success(
                    'Updated ' + values.swiperteamname + ' swipe team.'
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_UPDATESWIPETEAM_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

/**************** Deleting Swipe Teams - Consists of 2 Sagas below **********************************/
function* deleteSwipeTeamSaga(token, deptId, listId) {
    const abortController = new AbortController()
    let data

    try {
        data = yield call(
            deleteDataAPI,
            '/swipe-management/lists/' + deptId + '/' + listId,
            token,
            dataConstants.DATA_DELETESWIPETEAM_SUCCESS,
            dataConstants.DATA_DELETESWIPETEAM_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_DELETESWIPETEAM_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* deleteSwipeTeamDataSaga(action) {
    const {token, payload} = action
    const {swipeteamarray, deptId} = payload
    let status
    let deleteCount = 0

    for (let swipeteam of swipeteamarray) {
        status = yield call(
            deleteSwipeTeamSaga,
            token,
            deptId,
            swipeteam.listId
        )
        if (status === 204) deleteCount++
    }
    if (deleteCount > 0) {
        if (deleteCount > 1) {
            yield put(
                alertActions.success('Deleted ' + deleteCount + ' swipe teams')
            )
        } else {
            yield put(
                alertActions.success('Deleted ' + deleteCount + ' swipe team')
            )
        }
    }
    yield put(dataActions.swipeteamsFetchRequest(token, deptId))
}

function* engagementtypeSaga(action) {
    const abortController = new AbortController()
    let engagementtypelist

    const {token} = action

    try {
        engagementtypelist = yield call(
            getDataAPI,
            '/engagements',
            token,
            dataConstants.DATA_ENGAGEMENTTYPE_SUCCESS,
            dataConstants.DATA_ENGAGEMENTTYPE_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_ENGAGEMENTTYPE_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return engagementtypelist
}

function* departmentsDataSaga(action) {
    const abortController = new AbortController()
    let departmentslist

    const {token} = action

    try {
        departmentslist = yield call(
            getDataAPI,
            '/departments',
            token,
            dataConstants.DATA_DEPARTMENTS_SUCCESS,
            dataConstants.DATA_DEPARTMENTS_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_DEPARTMENTS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return departmentslist
}

/****** Set Active Department for Event Category and Occurrences */
function* setActiveDepartmentDataSaga(action) {
    const abortController = new AbortController()
    const {token, activedepartment} = action

    try {
        if (!isNaN(activedepartment.value)) {
            yield put(
                dataActions.setdepartmentsDataSuccess(activedepartment.value)
            )
            // call get data sagas that depend on deptId
            yield put(
                dataActions.eventcategoryFetchRequest(
                    token,
                    activedepartment.value
                )
            )
            yield put(dataActions.eventcategorySetClear({}))
            yield put(dataActions.eventoccurGetClear([]))

            yield put(
                dataActions.swipeteamsFetchRequest(
                    token,
                    activedepartment.value
                )
            )
        }
    } catch (err) {
        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_SETACTDEPARTMENT_FAILURE,
            message: err,
        })
        yield put({type: alertConstants.ERROR, message: err})
    }

    // return the active event category instance
    return activedepartment
}

function* superadminDataSaga(action) {
    const abortController = new AbortController()
    let superadminslist

    const {token} = action

    try {
        superadminslist = yield call(
            getDataAPI,
            '/users/super',
            token,
            dataConstants.DATA_GETSUPERADMINS_SUCCESS,
            dataConstants.DATA_GETSUPERADMINS_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_GETSUPERADMINS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return superadminslist
}

function* putSuperAdminDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {superadminarray, admin} = payload

    const body = {
        admin: admin,
    }
    try {
        data = yield call(
            putDataAPI,
            '/users/super/' + superadminarray[0].euid,
            token,
            body,
            dataConstants.DATA_PUTSUPERADMIN_SUCCESS,
            dataConstants.DATA_PUTSUPERADMIN_FAILURE,
            alertConstants.ERROR
        )
        if (data) {
            yield put(dataActions.getsuperadminsRequest(token))

            if (admin) {
                yield put(
                    alertActions.success(
                        'Added ' +
                            superadminarray[0].name +
                            ' to Super Admin role'
                    )
                )
            } else
                yield put(
                    alertActions.success(
                        'Removed ' +
                            superadminarray[0].firstName +
                            ' ' +
                            superadminarray[0].lastName +
                            ' Super Admin role'
                    )
                )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_PUTSUPERADMIN_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* setManageRoleDeptDataSaga(action) {
    const abortController = new AbortController()
    let manageroledept

    const {department} = action.payload

    try {
        if (!R.isEmpty(action.payload)) {
            manageroledept = department
            yield put(dataActions.manageroledeptSetSuccess(manageroledept))
        } else {
            manageroledept = {}
            yield put(dataActions.manageroledeptSetClear(manageroledept))
        }
    } catch (err) {
        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_SETMANAGEROLEDEPT_FAILURE,
            message: err,
        })
        yield put({type: alertConstants.ERROR, message: err})
    }

    // return the active department instance
    return manageroledept
}

function* addManageRolesDeptDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {values} = payload
    const body = {
        status: 'A',
        name: values.newdepartmentname,
        //descr: values.newdepartmentdescr,
    }

    try {
        data = yield call(
            postDataAPI,
            '/departments',
            token,
            body,
            dataConstants.DATA_ADDMANAGEROLEDEPT_SUCCESS,
            dataConstants.DATA_ADDMANAGEROLEDEPT_FAILURE,
            alertConstants.ERROR
        )
        if (data) {
            yield put(dataActions.departmentsDataRequest(token))

            yield put(
                dataActions.manageroledeptSetRequest({
                    token,
                    department: data,
                })
            )

            yield put(
                alertActions.success(
                    'Created ' + values.newdepartmentname + ' department.'
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_ADDMANAGEROLEDEPT_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* updateManageRolesDeptDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {values, activedepartment} = payload
    const body = {
        ...activedepartment,
        name: values.departmentname,
    }

    try {
        data = yield call(
            patchDataAPI,
            '/departments/' + activedepartment.deptId,
            token,
            body,
            dataConstants.DATA_UPDMANAGEROLEDEPT_SUCCESS,
            dataConstants.DATA_UPDMANAGEROLEDEPT_FAILURE,
            alertConstants.ERROR
        )

        if (data) {
            yield put(
                dataActions.manageroledeptSetRequest({
                    token,
                    department: data,
                })
            )
            yield put(
                alertActions.success(
                    'Updated ' + values.departmentname + ' department.'
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_UPDMANAGEROLEDEPT_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* deleteManageRolesDeptDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {activedepartment} = payload
    const {deptId} = activedepartment

    try {
        data = yield call(
            deleteDataAPI,
            '/departments/' + deptId,
            token,
            dataConstants.DATA_DELMANAGEROLEDEPT_SUCCESS,
            dataConstants.DATA_DELMANAGEROLEDEPT_FAILURE,
            alertConstants.ERROR
        )
        if (data === 204) {
            let manageroledept = []
            yield put(dataActions.departmentsDataRequest(token))
            yield put(dataActions.manageroledeptSetClear(manageroledept))
            yield put(
                alertActions.success(
                    'Deleted ' + activedepartment.name + ' department.'
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_DELMANAGEROLEDEPT_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* departmentusersDataSaga(action) {
    const abortController = new AbortController()
    let departmentusers
    let result

    const {token, department} = action.payload

    try {
        if (!R.isEmpty(department)) {
            result = yield call(
                getDataAPI,
                '/departments/' + department.deptId,
                token,
                dataConstants.DATA_GETDEPARTMENTUSERS_SUCCESS,
                dataConstants.DATA_GETDEPARTMENTUSERS_FAILURE,
                alertConstants.ERROR
            )

            if (result) {
                departmentusers = result
            } else {
                departmentusers = []
                yield put(dataActions.departmentusersGetClear(departmentusers))
            }
        } else {
            departmentusers = []
            yield put(dataActions.departmentusersGetClear(departmentusers))
        }
    } catch (err) {
        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_GETDEPARTMENTUSERS_FAILURE,
            message: err,
        })
        yield put({type: alertConstants.ERROR, message: err})
    }

    // return the active event occurrence instance
    return departmentusers
}

/******************* ADD Department Users Saga - Consists of 2 sagas below *************/
function* addDepartmentUserSaga(token, user, role, deptId) {
    const abortController = new AbortController()
    let data

    const body = {
        role: role,
        active: true,
    }

    try {
        data = yield call(
            putDataAPI,
            '/departments/' + deptId + '/' + user.euid,
            token,
            body,
            dataConstants.DATA_ADDDEPARTMENTUSERS_SUCCESS,
            dataConstants.DATA_ADDDEPARTMENTUSERS_FAILURE,
            alertConstants.ERROR
        )

        if (data) {
            yield put(
                alertActions.success(
                    'Added ' + user.name + ' to department ' + role
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_ADDDEPARTMENTUSERS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* addDepartmentUsersDataSaga(action) {
    const {token, payload} = action
    const {userarray, role, department} = payload
    const deptId = department.deptId

    for (let user of userarray) {
        yield call(addDepartmentUserSaga, token, user, role, deptId)
    }
    yield put(
        dataActions.departmentusersGetRequest({
            token,
            department,
        })
    )
    yield put(userActions.getUserProfileRequest(token))
}

/******************* UPDATE Department Users Saga *************/
function* updateDepartmentUsersDataSaga(action) {
    const abortController = new AbortController()
    let data

    const {token, payload} = action
    const {values, user, department} = payload
    const deptId = department.deptId

    const body = {
        role: values.departmentrole,
        active: true,
    }

    try {
        data = yield call(
            putDataAPI,
            '/departments/' + deptId + '/' + user.euid,
            token,
            body,
            dataConstants.DATA_UPDDEPARTMENTUSERS_SUCCESS,
            dataConstants.DATA_UPDDEPARTMENTUSERS_FAILURE,
            alertConstants.ERROR
        )

        yield put(userActions.getUserProfileRequest(token))

        if (data) {
            yield put(
                alertActions.success(
                    'Updated ' +
                        user.firstName +
                        ' ' +
                        user.lastName +
                        ' to department ' +
                        values.departmentrole
                )
            )
        }
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_UPDDEPARTMENTUSERS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

/**************** Deleting Department Users - Consists of 2 Sagas below **********************************/
function* deleteDepartmentUserSaga(token, user, deptId) {
    const abortController = new AbortController()
    let data

    try {
        data = yield call(
            deleteDataAPI,
            '/departments/' + deptId + '/' + user.euid,
            token,
            dataConstants.DATA_DELDEPARTMENTUSERS_SUCCESS,
            dataConstants.DATA_DELDEPARTMENTUSERS_FAILURE,
            alertConstants.ERROR
        )
    } catch (err) {
        const errorMessage = err.title + ': ' + err.message

        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_DELDEPARTMENTUSERS_FAILURE,
            message: errorMessage,
        })
        yield put({type: alertConstants.ERROR, message: errorMessage})
    }

    return data
}

function* deleteDepartmentUsersDataSaga(action) {
    const {token, payload} = action
    const {userarray, department} = payload
    const deptId = department.deptId
    let status
    let deleteCount = 0

    for (let user of userarray) {
        status = yield call(deleteDepartmentUserSaga, token, user, deptId)

        if (status === 204) {
            deleteCount++
        }
    }

    if (deleteCount > 0) {
        if (deleteCount > 1) {
            yield put(
                alertActions.success(
                    'Deleted ' + deleteCount + ' department roles'
                )
            )
        } else {
            yield put(
                alertActions.success(
                    'Deleted ' + deleteCount + ' department role'
                )
            )
        }
    }
    yield put(
        dataActions.departmentusersGetRequest({
            token,
            department,
        })
    )
    yield put(userActions.getUserProfileRequest(token))
}

function* allusersDataSaga(action) {
    const abortController = new AbortController()
    let allusers
    let result

    const {token} = action

    try {
        result = yield call(
            getDataAPI,
            '/users/all',
            token,
            dataConstants.DATA_GETALLUSERS_SUCCESS,
            dataConstants.DATA_GETALLUSERS_FAILURE,
            alertConstants.ERROR
        )
        if (result) {
            allusers = result
        } else {
            allusers = []
            yield put(dataActions.allusersGetClear(allusers))
        }
    } catch (err) {
        if (yield cancelled()) {
            //Cancel the API call if the saga was cancelled
            abortController.abort()
        }

        yield put({
            type: dataConstants.DATA_GETALLUSERS_FAILURE,
            message: err,
        })
        yield put({type: alertConstants.ERROR, message: err})
    }

    // return the active event occurrence instance
    return allusers
}
